import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';

export const initSwiper = () => {
  Swiper.use([Navigation, Pagination, Autoplay]);

  const swiper1 = new Swiper('.swiper1', {
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    grabCursor: true,
    allowTouchMove: false,
    simulateTouch: false,
    // effect: 'fade',        // ← 複数スライド表示時は外す
    // fadeEffect: { crossFade: true }, // 同上
    pagination: {
      el: '.swiper-pagination1',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1.3,
    spaceBetween: 10,
    centeredSlides: true,  // 真ん中を中心に表示
    roundLengths: true,
    speed: 400,

    // 画面幅が768px以上の場合の設定（例）
    breakpoints: {
      768: {
        // 3つ表示し、真ん中をメインに左右が少し見えるイメージ
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: true,
      },
    },
  });
  const swiperPivlaz = new Swiper('.swiper-pivlaz', {
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    grabCursor: true,
    allowTouchMove: false,
    simulateTouch: false,
    pagination: {
      el: '.swiper-pagination-pivlaz',
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: true,
    roundLengths: true,
    speed: 400,
  });
};
